import { NavbarContainer } from "./Navbar.styles";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

export const NavBar = () => {
  return (
    <NavbarContainer>
      <ul>
          <CustomLink to="/" className="Teltec">Teltec</CustomLink>
          <CustomLink to="/teltec-core" className="Teltec Core">Teltec Core</CustomLink>
          <CustomLink to="/teltec-data" className="Teltec Data">Teltec Data</CustomLink>
      </ul>
    </NavbarContainer>
  );
};

function CustomLink({ to, children, ...props }: any) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({path: resolvedPath.pathname, end: true})
  return (
    <>
    <li className={isActive? "active" : ""}>
      <Link to={to} {...props}>{children}</Link>
    </li>
    </>
  )
}
